/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 * Rana simulation API (latest stable version: v3)   Framework release: 3.5.51   Rana simulation core release: 3.7.3   deployed on:  10:12AM (UTC) on September 07, 2026
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { FileReadOnly } from "./FileReadOnly";
import {
  FileReadOnlyFromJSON,
  FileReadOnlyFromJSONTyped,
  FileReadOnlyToJSON,
  FileReadOnlyToJSONTyped,
} from "./FileReadOnly";
import type { DimensionEnum } from "./DimensionEnum";
import {
  DimensionEnumFromJSON,
  DimensionEnumFromJSONTyped,
  DimensionEnumToJSON,
  DimensionEnumToJSONTyped,
} from "./DimensionEnum";
import type { EventStateEnum } from "./EventStateEnum";
import {
  EventStateEnumFromJSON,
  EventStateEnumFromJSONTyped,
  EventStateEnumToJSON,
  EventStateEnumToJSONTyped,
} from "./EventStateEnum";

/**
 * A type of `ModelSerializer` that uses
 * hyperlinked relationships with compound keys instead
 * of primary key relationships.  Specifically:
 * * A 'url' field is included instead of the 'id' field.
 * * Relationships to other instances are hyperlinks, instead of primary keys.
 * NOTE: this only works with DRF 3.1.0 and above.
 * @export
 * @interface InitialWaterlevel
 */
export interface InitialWaterlevel {
  /**
   *
   */
  readonly url?: string;
  /**
   *
   */
  readonly threedimodel?: string;
  /**
   *
   */
  userGenerated?: boolean;
  /**
   *
   */
  readonly file?: FileReadOnly;
  /**
   *
   */
  sourceRaster?: string;
  /**
   *
   */
  readonly state?: EventStateEnum;
  /**
   *
   */
  readonly stateDetail?: any | null;
  /**
   *
   */
  readonly id?: number;
  /**
   *
   */
  readonly sourceRasterId?: number | null;
  /**
   *
   */
  dimension?: DimensionEnum;
}

/**
 * Check if a given object implements the InitialWaterlevel interface.
 */
export function instanceOfInitialWaterlevel(value: object): value is InitialWaterlevel {
  return true;
}

export function InitialWaterlevelFromJSON(json: any): InitialWaterlevel {
  return InitialWaterlevelFromJSONTyped(json, false);
}

export function InitialWaterlevelFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): InitialWaterlevel {
  if (json == null) {
    return json;
  }
  return {
    url: json["url"] == null ? undefined : json["url"],
    threedimodel: json["threedimodel"] == null ? undefined : json["threedimodel"],
    userGenerated: json["user_generated"] == null ? undefined : json["user_generated"],
    file: json["file"] == null ? undefined : FileReadOnlyFromJSON(json["file"]),
    sourceRaster: json["source_raster"] == null ? undefined : json["source_raster"],
    state: json["state"] == null ? undefined : EventStateEnumFromJSON(json["state"]),
    stateDetail:
      json["state_detail"] === undefined
        ? undefined
        : json["state_detail"] === null
        ? null
        : json["state_detail"],
    id: json["id"] == null ? undefined : json["id"],
    sourceRasterId:
      json["source_raster_id"] === undefined
        ? undefined
        : json["source_raster_id"] === null
        ? null
        : json["source_raster_id"],
    dimension: json["dimension"] == null ? undefined : DimensionEnumFromJSON(json["dimension"]),
  };
}

export function InitialWaterlevelToJSON(json: any): InitialWaterlevel {
  return InitialWaterlevelToJSONTyped(json, false);
}

export function InitialWaterlevelToJSONTyped(
  value?: Omit<
    InitialWaterlevel,
    "url" | "threedimodel" | "file" | "state" | "stateDetail" | "id" | "sourceRasterId"
  > | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    user_generated: value["userGenerated"],
    source_raster: value["sourceRaster"],
    dimension: DimensionEnumToJSON(value["dimension"]),
  };
}
